module.exports = __webpack_public_path__ + "img/magnifying-glass.8b258b82.svg";